import type { IntersectionValue } from 'quasar'
import type { ComponentPublicInstance } from '@/composition/vue/compositionApi'
import type BaseModel from '@/data/models/BaseModel'
import type { TableRowExtended } from '@/core/tables/baseTableInterface'
import type { RegisteredServices } from '@/core/container/types'
import type { DefaultColumn } from '@/core/tables/types'
import type { TableAlignment } from '@/services/tables/types'
import type { TranslationKey } from '@/services/types'

export enum TableTheme {
  DEFAULT = 'default',
  BORDERLESS = 'borderless',
}

export type TmTableProps = {
  serviceId: RegisteredServices
  scrollable?: boolean
  rowActions?: boolean
  hideCheckboxes?: boolean
  hideFooter?: boolean
  rowBold?: (row: any) => boolean
  singleSelection?: boolean
  fixedLayout?: boolean
  actionsWidth?: number
  i18nEntityName?: string
  theme?: TableTheme
  hidePerPage?: boolean
  selectedActionsTextMessagePath?: TranslationKey
  columnsLabelsOverride?: Record<string, string>
  keepStateWhileLoading?: boolean
  skeletonRowsToDisplay?: number
}

export type TableLayoutSlotProps<T extends BaseModel = BaseModel> = {
  rowsLoading: boolean
  hasSelectedRows: boolean
  rows: TableRowExtended<T>[]
  isNewSizingFlowEnabled: boolean
  columns: DefaultColumn[]
  isRowVisible: (row: string) => boolean
  getIntersectionOptions: (row: string) => IntersectionValue
  getIntersectionRef: (row: string) => (el: Element | ComponentPublicInstance | null) => void
  alignment: TableAlignment | null
  searchQuery: string
  isExpanded: boolean
  hasOtherStickyCells: boolean
  columnsLabelsOverride?: Record<string, string>

  fixedLayout?: boolean
  singleSelection?: boolean
  theme?: TableTheme
  scrollable?: boolean
  rowActions?: boolean
  actionsWidth?: number
  hideCheckboxes?: boolean
  tmTableContainerNodeEl?: HTMLElement
  rowBold?: (row: any) => boolean
  skeletonRowsToDisplay?: number
}

export type TmTableViewProps<T extends BaseModel = BaseModel> = TableLayoutSlotProps<T> & {
  serviceId: RegisteredServices
}
